export const contact = {
  hero: {
    title: 'Let\'s Talk About Your Project',
    description: 'Tell us about your business and discover how we can help you automate your appointment management. We will respond within 24 hours.'
  },
  form: {
    title: 'Request Information',
    namePlaceholder: 'Your full name',
    emailPlaceholder: 'your@email.com',
    phonePlaceholder: '+34 600 000 000',
    companyPlaceholder: 'Your clinic or business name',
    messagePlaceholder: 'Tell us what you need...',
    success: 'Thank you, we will contact you within 24 hours.'
  },
  demo: {
    title: 'Want a Demo?',
    description: 'Schedule a personalized demonstration and discover how our solutions can transform your business.'
  }
};
